<template>
<div v-loading="rankingLoading">
  <router-link :to="{name: 'events.details', params: {id: event._id}}">
    <button
      v-if="$can('events.details')"
      class="btn btn-fill btn-wd btn-info btn-block btn-router"
    >
      Ver detalhes do evento
    </button>
  </router-link>

  <button
    v-if="$can('ranking.create')"
    :disabled="rankingLoading || event.drawn || minimumSurveys || event.status === 2 || !this.tickets.length"
    @click="runMakeRanking"
    class="btn btn-fill btn-wd btn-success btn-block btn-router"
  >
    Gerar Ranking
  </button>

  <button
    v-if="event.drawn && $can('ranking.print.winners')"
    @click="printWinnerList()"
    class="btn btn-fill btn-wd btn-default btn-block btn-router"
  >
    Imprimir lista de ganhadores
  </button>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ranking-actions',

  props: {
    tickets: {
      required: true
    },
    event: {
      required: true
    }
  },

  computed: {
    ...mapGetters('surveys', {
      surveys: 'surveyValid'
    }),

    ...mapGetters('ranking', {
      rankingLoading: 'loading'
    }),

    minimumSurveys () {
      return this.surveys.length < Number(this.event.numberOfRefigerators)
    }
  },

  methods: {
    ...mapActions('tickets', ['makeRanking']),
    ...mapActions('ranking', { setRankingLoading: 'changeLoading' }),

    runMakeRanking () {
      this.setRankingLoading(true)
      let tickets = this.generateTicketsSortRanking()
      this.makeRanking(tickets)
        .then(() => {
          this.$notify({
            message: 'Ranking gerado com sucesso',
            type: 'success'
          })
        })
        .catch(() => {
          this.$notify({
            message: 'Houve um problema para gerar o ranking',
            type: 'error'
          })
        })
        .finally(() => {
          this.setRankingLoading(false)
          this.$emit('runMakeRanking')
        })
    },

    generateTicketsSortRanking () {
      let tickets = this.tickets.map(ticketMap => {
        let survey = this.surveys.find(survey => {
          return survey.ticketId === ticketMap._id
        })
        return {
          ...ticketMap,
          survey
        }
      })
      .sort((a, b) => this.sortRanking(a, b))
      .map((ticketMapRankingOriginal, index) => {
        return {
          ...ticketMapRankingOriginal,
          rankingOriginal: Number(index) + 1,
          rankingNow: Number(index) + 1
        }
      })

      return tickets
    },

    sortRanking (a, b) {
      // Ao alterar esta função, deve-se alterar também a função em RankingList.vue
      let scoreA = a.survey && a.survey.data && a.survey.data.refrigerator && a.survey.data.refrigerator.score ? a.survey.data.refrigerator.score : 0
      let scoreB = b.survey && b.survey.data && b.survey.data.refrigerator && b.survey.data.refrigerator.score ? b.survey.data.refrigerator.score : 0

      let refrigeratorAgeA = a.survey && a.survey.data && a.survey.data.refrigerator && a.survey.data.refrigerator.yearsUse ? a.survey.data.refrigerator.yearsUse : 0
      let refrigeratorAgeB = b.survey && b.survey.data && b.survey.data.refrigerator && b.survey.data.refrigerator.yearsUse ? b.survey.data.refrigerator.yearsUse : 0

      // Para que a ordenação de ordem decrescente funcione, precisará do complemento da data
      let ageCustomerA = new Date(a.createdAt)
      let complementaryAgeCustomerA = '' + (10000 - ageCustomerA.getYear()) + (100 - ageCustomerA.getMonth()) + (100 - ageCustomerA.getDay())
      let ageCustomerB = new Date(b.createdAt)
      let complementaryAgeCustomerB = '' + (10000 - ageCustomerB.getYear()) + (100 - ageCustomerB.getMonth()) + (100 - ageCustomerB.getDay())

      let totalScoreA = ('' + scoreA + refrigeratorAgeA + complementaryAgeCustomerA)
      let totalScoreB = ('' + scoreB + refrigeratorAgeB + complementaryAgeCustomerB)

      if (a.hasOwnProperty('absentAt') || b.hasOwnProperty('absentAt')) {
        totalScoreA = Number(a.absentAt ? 1 : 0) + totalScoreA
        totalScoreB = Number(b.absentAt ? 1 : 0) + totalScoreB

        return totalScoreB.localeCompare(totalScoreA)
      }

      if (a.energyMetering || b.energyMetering) {
        totalScoreA = Number(a.energyMetering ? 1 : 0) + totalScoreA
        totalScoreB = Number(b.energyMetering ? 1 : 0) + totalScoreB

        return totalScoreB.localeCompare(totalScoreA)
      }

      return totalScoreB.localeCompare(totalScoreA)
    },

    printWinnerList () {
      let routeData = this.$router.resolve({
        name: 'ranking.print.winners',
        params: { id: this.event._id }
      })
      window.open(
        routeData.href,
        'ticketWindow',
        'menubar=false,location=false,resizable=false,scrollbars=1,status=false'
      )
      return true
    }
  }
}
</script>

<style scoped>
  .btn-router {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Ranking/RankingActions.vue